import type { TrialBannerBucket } from "~/helpers/trialBannerEscalation";

const BUCKETS: readonly TrialBannerBucket[] = ["normal", "warning", "critical"];

const bucketKey = (bucket: TrialBannerBucket): string => `trialBanner.dismissed.${bucket}`;

const readDismissedBuckets = (): ReadonlySet<TrialBannerBucket> => {
	try {
		return new Set(BUCKETS.filter((bucket) => sessionStorage.getItem(bucketKey(bucket)) === "true"));
	} catch {
		return new Set();
	}
};

const markBucketDismissed = (bucket: TrialBannerBucket): void => {
	try {
		sessionStorage.setItem(bucketKey(bucket), "true");
	} catch {
		// sessionStorage can be unavailable in private mode
	}
};

const trialBannerDismissal = { markBucketDismissed, readDismissedBuckets };

export default trialBannerDismissal;
